import { useState } from 'react';
import { Phone } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface UpdatePhoneDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (phoneNumber: string) => void;
  initialPhone?: string;
}

export function UpdatePhoneDialog({
  open,
  onClose,
  onSubmit,
  initialPhone,
}: UpdatePhoneDialogProps) {
  const [phoneNumber, setPhoneNumber] = useState(initialPhone || '');

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>تحديث رقم الهاتف</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="phone">رقم الهاتف الجديد</Label>
            <Input
              id="phone"
              type="tel"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              dir="ltr"
              className="text-left"
            />
          </div>
          <div className="flex justify-start gap-2">
            <Button
              onClick={() => onSubmit(phoneNumber)}
              className="hover:bg-secondary"
            >
              <Phone className="h-4 w-4 ml-2" />
              تحديث
            </Button>
            <Button
              variant="ghost"
              onClick={onClose}
            >
              إلغاء
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}